/* Card names and descriptions arrive from the API in English, because they are
   rows a Game Master authors — not UI strings. The creation flow then shows them
   verbatim next to fully translated chrome, so a Ukrainian player met "Blood
   School" and "Drunken Wanderer" in the middle of their own language.

   The lookup is keyed by a slug derived from the English name rather than by the
   row's uuid: uuids differ between every database (a fresh `db-restore`, a
   colleague's machine, production), so a uuid-keyed table would translate
   nothing anywhere but the machine it was written on. The English name is the
   one stable identifier this content has.

   Missing keys fall back to the API value. That is the important half — a GM can
   add a school tonight and it shows up in English rather than as a raw key. */

export function slugOf(name) {
    return String(name ?? '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
}

/* `te` is vue-i18n's "does this key exist" test. Without it a missing entry
   renders the key path itself, which looks like a bug rather than like untranslated
   content. */
export function cardTextOf(t, te, kind, item) {
    const slug = slugOf(item?.name);
    const base = `player.creation.cards.${kind}.${slug}`;
    const name = slug && te(`${base}.name`) ? t(`${base}.name`) : (item?.name ?? '');
    const description = slug && te(`${base}.description`)
        ? t(`${base}.description`)
        : (item?.description ?? '');
    return {name, description};
}
